import React, {useState, useEffect} from 'react'
import './../css/user_registration.css';
import {withRouter} from 'react-router-dom'
import { connect } from 'react-redux'

import { addField } from '../../redux/actions';
import Language from './../../components/common/language/lang'
import CP_Next_2 from './../../media/2_CP_Next.png'
import logo from './../../media/logo.svg'

import controlDataUReg from './../../components/userRegistration/URegData_control'
import SelectNazione from './../../components/common/dropDownMenu/ita/select_nazione'
import SelectSettore from './../../components/common/dropDownMenu/ita/select_settore'

const UserRegistration = (props) => {
   
   const changePage = slug => {
      props.history.push(slug)
   }

   const [FormData, setFormData] = useState({
      NomeUtente: props.form.NomeUtente,
      CognomeUtente: props.form.CognomeUtente,
      Azienda: props.form.Azienda,
      Email: props.form.Email,
      IndirizzoAzienda: props.form.IndirizzoAzienda,
      NazioneAzienda: props.form.NazioneAzienda,
      CittaAzienda: props.form.CittaAzienda,
      ProvinciaAzienda: props.form.ProvinciaAzienda,
      CAPAzienda: props.form.CAPAzienda,
      Telefono: props.form.Telefono,
      Settore: props.form.Settore
   })

   const [click,setClick] = useState(false);

   useEffect(() => {
      setTimeout(() => {
         if(click){
            setClick((prev)=>prev=false)
         }
      }, 500)      
   }, [FormData])

   useEffect(() => {
      [nomeCorretto,cognomeCorretto,aziendaCorretto,emailCorretto,indirizzoCorretto,nazioneCorretto,cittaCorretto,provinciaCorretto,capCorretto,telefonoCorretto]=controlDataUReg(FormData)  
   }, [nomeCorretto,cognomeCorretto,aziendaCorretto,emailCorretto,indirizzoCorretto,nazioneCorretto,cittaCorretto,provinciaCorretto,capCorretto,telefonoCorretto])

   const submitMReg = () => {
      props.add("NomeUtente",FormData.NomeUtente);
      props.add("CognomeUtente",FormData.CognomeUtente);
      props.add("Azienda",FormData.Azienda);
      props.add("Email",FormData.Email);
      props.add("IndirizzoAzienda",FormData.IndirizzoAzienda);
      props.add("NazioneAzienda",FormData.NazioneAzienda);
      props.add("CittaAzienda",FormData.CittaAzienda);
      props.add("ProvinciaAzienda",FormData.ProvinciaAzienda);
      props.add("CAPAzienda",FormData.CAPAzienda);
      props.add("Telefono",FormData.Telefono);
      changePage('/machine-registration');
   }

   var nomeCorretto = false ,cognomeCorretto = false ,aziendaCorretto = false ,emailCorretto = false ,indirizzoCorretto = false ,nazioneCorretto = false ,cittaCorretto = false ,provinciaCorretto = false ,capCorretto = false ,telefonoCorretto;

   var pressInvio = (event) => {

      [nomeCorretto,cognomeCorretto,aziendaCorretto,emailCorretto,indirizzoCorretto,nazioneCorretto,cittaCorretto,provinciaCorretto,capCorretto,telefonoCorretto]=controlDataUReg(FormData)
      
      if (event.keyCode === 13){
         if (nomeCorretto && cognomeCorretto && aziendaCorretto && emailCorretto && indirizzoCorretto && nazioneCorretto && cittaCorretto && provinciaCorretto && capCorretto && telefonoCorretto){
            submitMReg()
         }else{
            setClick((prev)=>prev=true)
         }
      }
   }

   return (
      <div className="m_form" onKeyDown={(event)=>pressInvio(event)}>
         <div className="first_block">
            <a href="https://www.irinoxprofessional.com/ita/" target="_blank"><img className="logo" alt="logo" src={logo}/></a>
            <div className="langMReg"><Language  color={"#002445"}/></div>
         </div>
            
         <div className="twoblocksMReg">
            <div className="formMReg">
               <div className="formTitleMReg">INFORMAZIONI UTENTE</div>
               <div className="columnsMReg">

                  {[nomeCorretto,cognomeCorretto,aziendaCorretto,emailCorretto,indirizzoCorretto,nazioneCorretto,cittaCorretto,provinciaCorretto,capCorretto,telefonoCorretto]=controlDataUReg(FormData)} 
                  
                  <div className="textInput "><TextInput fieldErrorMReg={!nomeCorretto&&click ?  (true) : (false)} 
                     onChange={(valore)=>
                        setFormData((prev) => ({
                           ...prev,
                           NomeUtente: valore
                        }))}
                        default_value={props.form.NomeUtente}
                     placeholder="il tuo nome" label="NOME*"/></div>

                  {[nomeCorretto,cognomeCorretto,aziendaCorretto,emailCorretto,indirizzoCorretto,nazioneCorretto,cittaCorretto,provinciaCorretto,capCorretto,telefonoCorretto]=controlDataUReg(FormData)}


                  <div className="textInput "><TextInput fieldErrorMReg={!cognomeCorretto&&click ?  (true) : (false)}
                     onChange={(valore)=>
                        setFormData((prev) => ({
                           ...prev,
                           CognomeUtente: valore
                        }))}
                        default_value={props.form.CognomeUtente}
                     placeholder="il tuo cognome" label="COGNOME*"/></div>
                  
                  {[nomeCorretto,cognomeCorretto,aziendaCorretto,emailCorretto,indirizzoCorretto,nazioneCorretto,cittaCorretto,provinciaCorretto,capCorretto,telefonoCorretto]=controlDataUReg(FormData)} 
                  
                  <div className="textInput "><TextInput fieldErrorMReg={!aziendaCorretto&&click ?  (true) : (false)}  
                     onChange={(valore)=>
                        setFormData((prev) => ({
                           ...prev,
                           Azienda: valore
                        }))}
                        default_value={props.form.Azienda}
                     placeholder="il nome della tua azienda" label="AZIENDA*"/></div>
                  
                  {[nomeCorretto,cognomeCorretto,aziendaCorretto,emailCorretto,indirizzoCorretto,nazioneCorretto,cittaCorretto,provinciaCorretto,capCorretto,telefonoCorretto]=controlDataUReg(FormData)} 
                  
                  <div className="textInput "><TextInput fieldErrorMReg={!emailCorretto&&click ?  (true) : (false)} 
                     onChange={(valore)=>
                        setFormData((prev) => ({
                           ...prev,
                           Email: valore
                        }))}
                        default_value={props.form.Email}
                     placeholder="la tua email" label="EMAIL*"/></div>

                  {[nomeCorretto,cognomeCorretto,aziendaCorretto,emailCorretto,indirizzoCorretto,nazioneCorretto,cittaCorretto,provinciaCorretto,capCorretto,telefonoCorretto]=controlDataUReg(FormData)}

                  <div className="textInput "><TextInput fieldErrorMReg={!indirizzoCorretto&&click ?  (true) : (false)} 
                     onChange={(valore)=>
                        setFormData((prev) => ({
                           ...prev,
                           IndirizzoAzienda: valore
                        }))}
                        default_value={props.form.IndirizzoAzienda}
                     placeholder="l’indirizzo della sede legale della tua azienda" label="INDIRIZZO*"/></div>
                  
                  {[nomeCorretto,cognomeCorretto,aziendaCorretto,emailCorretto,indirizzoCorretto,nazioneCorretto,cittaCorretto,provinciaCorretto,capCorretto,telefonoCorretto]=controlDataUReg(FormData)}

                  <div className="textInput "><SelectNazione fieldErrorMReg={!nazioneCorretto&&click ?  (true) : (false)}
                     onChange={(valore)=>
                        setFormData((prev) => ({
                           ...prev,
                           NazioneAzienda: valore
                        }))}
                        default_value={props.form.NazioneAzienda}
                     placeholder="la nazione della tua azienda" label="NAZIONE*"/></div>

                  {[nomeCorretto,cognomeCorretto,aziendaCorretto,emailCorretto,indirizzoCorretto,nazioneCorretto,cittaCorretto,provinciaCorretto,capCorretto,telefonoCorretto]=controlDataUReg(FormData)}

                  <div className="textInput "><TextInput fieldErrorMReg={!cittaCorretto&&click ?  (true) : (false)} 
                     onChange={(valore)=>
                        setFormData((prev) => ({
                           ...prev,
                           CittaAzienda: valore
                        }))}
                        default_value={props.form.CittaAzienda}
                     placeholder="la città " label="CITTÀ*"/></div>

                  <div className="coupleAddr"> 
                     
                     {[nomeCorretto,cognomeCorretto,aziendaCorretto,emailCorretto,indirizzoCorretto,nazioneCorretto,cittaCorretto,provinciaCorretto,capCorretto,telefonoCorretto]=controlDataUReg(FormData)}

                     <div className="textInput"><TextInput fieldErrorMReg={!provinciaCorretto&&click ?  (true) : (false)}
                        onChange={(valore)=>
                           setFormData((prev) => ({
                              ...prev,
                              ProvinciaAzienda: valore
                           }))}
                           default_value={props.form.ProvinciaAzienda}
                        placeholder="la provincia " label="PROVINCIA*" couple={true}/></div>
                     
                     {[nomeCorretto,cognomeCorretto,aziendaCorretto,emailCorretto,indirizzoCorretto,nazioneCorretto,cittaCorretto,provinciaCorretto,capCorretto,telefonoCorretto]=controlDataUReg(FormData)}

                     <div className="textInput"><TextInput fieldErrorMReg={!capCorretto&&click ?  (true) : (false)}
                        onChange={(valore)=>
                           setFormData((prev) => ({
                              ...prev,
                              CAPAzienda: valore
                           }))}
                           default_value={props.form.CAPAzienda}
                        placeholder="il CAP " label="CAP*" couple={true}/></div>
                  </div>


                  {[nomeCorretto,cognomeCorretto,aziendaCorretto,emailCorretto,indirizzoCorretto,nazioneCorretto,cittaCorretto,provinciaCorretto,capCorretto,telefonoCorretto]=controlDataUReg(FormData)}

                  <div className="textInput "><TextInput fieldErrorMReg={!telefonoCorretto&&click ?  (true) : (false)}
                     onChange={(valore)=>
                        setFormData((prev) => ({
                           ...prev,
                           Telefono: valore
                        }))}
                        default_value={props.form.Telefono}
                     placeholder="il numero di telefono " label="TELEFONO*"/></div>

                  <div className="textInput "><SelectSettore
                     onChange={(valore)=>
                        setFormData((prev) => ({
                           ...prev,
                           Settore: valore
                        }))}
                     placeholder="il settore della tua azienda" label="SETTORE"/></div>
                  
               </div>
               <div className="tipMReg">(* campi obbligatori)</div>
               <div className="buttonsMReg"> 
                  <div className="pointer empty_button buttonMReg" onClick={() => {changePage('/')}}>Torna alla pagina iniziale</div>

                  {[nomeCorretto,cognomeCorretto,aziendaCorretto,emailCorretto,indirizzoCorretto,nazioneCorretto,cittaCorretto,provinciaCorretto,capCorretto,telefonoCorretto]=controlDataUReg(FormData)}               
                  <div className="pointer filled_button" onClick={() => { nomeCorretto && cognomeCorretto && aziendaCorretto && emailCorretto && indirizzoCorretto && nazioneCorretto && cittaCorretto && provinciaCorretto && capCorretto && telefonoCorretto
                      ? submitMReg() : (setClick((prev)=>prev=true))}}>Registrati</div>
               </div>
               
            </div>
            <div className="parteDestra">
               <img src={CP_Next_2} className="Cp3MReg"/>
               <div className="cpN2_descr">
                  <span className="cpN2_descr_title">Registrati per:</span><br/>
                  <div>
                     ▪ Avere sempre il tuo CP Next sottocontrollo<br/>
                     ▪ Scaricare i tuoi dati HACCP<br/>
                     ▪ Controllare in tempo reale le temperature da remoto<br/>
                  </div>
                  
               </div>
            </div>
            
         </div>
      </div>
   )
}

const mapActionToProps = {
   add: (field,fieldValue) => addField(field,fieldValue)
}

export default connect(               
   state => { 
      return {form: state.form}
  },
   mapActionToProps
) (withRouter(UserRegistration))

const TextInput = ({onChange,placeholder,label,couple,fieldErrorMReg,default_value}) => (
   <>
      <div>
         <div className="labelcss">{label}</div>
      </div>      
      <input className={fieldErrorMReg ? ("fieldErrorMReg inputcss"): ("inputcss")}type="text"
         placeholder={"Inserisci "+placeholder}
         defaultValue={default_value}
         onChange={(event) => onChange(event.target.value)}
      />
   </>
)